import { __awaiter, __generator } from "tslib";
import { request } from '../lib/request';
var createPayload = function (params) {
    return params.purchaseToken
        ? {
            'purchase_token': params.purchaseToken
        }
        : {};
};
export var bindSbpTokenApi = function (apiHost, params) { return __awaiter(void 0, void 0, void 0, function () {
    var payload, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = createPayload(params);
                return [4, request({
                        method: 'POST',
                        url: "".concat(apiHost, "/web/bind_sbp_token"),
                        params: payload,
                        body: payload
                    })];
            case 1:
                response = _a.sent();
                return [2, response.form_url];
        }
    });
}); };
